import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import Menu from 'antd/lib/menu';
import Icon from 'antd/lib/icon';
import { MenuItemLink } from '../../../common/components';
import { ResponsiveMenu } from '../../../common/components/hoc';
import { accountRoles } from '../../../common/enums';

@translate()
@ResponsiveMenu()
export default class AccountDetailMenu extends Component {
  static propTypes = {
    accountFullName: PropTypes.string,
    accountId: PropTypes.string.isRequired,
    accountRole: PropTypes.string,
    menuMode: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const { accountFullName, accountRole, accountId, t, menuMode } = this.props;

    return (
      <Row>
        <Col xs={12}>
          <h2>{accountFullName || '\u00a0'}</h2>
        </Col>

        <Col xs={12}>
          <Menu mode={menuMode}>
            {[accountRoles.DEBTOR, accountRoles.CREDITOR].includes(accountRole) && (
              <MenuItemLink to={`/admin/accounts/${accountId}/profile`} onlyActiveOnIndex>
                <Icon type="user" />
                {t('Profil')}
              </MenuItemLink>
            )}

            {accountRole === accountRoles.DEBTOR && (
              <MenuItemLink to={`/admin/accounts/${accountId}/loans`} onlyActiveOnIndex>
                <Icon type="file-text" />
                {t('Pôžičky')}
              </MenuItemLink>
            )}

            {accountRole === accountRoles.CREDITOR && (
              <MenuItemLink to={`/admin/accounts/${accountId}/allocations`} onlyActiveOnIndex>
                <Icon type="file-text" />
                {t('Investície')}
              </MenuItemLink>
            )}

            <MenuItemLink to={`/admin/accounts/${accountId}/documents`} onlyActiveOnIndex>
              <Icon type="file" />
              {t('Dokumenty')}
            </MenuItemLink>

            {accountRole === accountRoles.CREDITOR && (
              <MenuItemLink to={`/admin/accounts/${accountId}/exports`} onlyActiveOnIndex>
                <Icon type="export" /> 
                {t('Exporty')}
              </MenuItemLink>
            )}

            {[accountRoles.DEBTOR, accountRoles.CREDITOR].includes(accountRole) && (
              <MenuItemLink to={`/admin/accounts/${accountId}/messages`} onlyActiveOnIndex>
                <Icon type="edit" />
                {t('Komunikácia')}
              </MenuItemLink>
            )}
          </Menu>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/components/AccountDetailMenu.js